export const INSIDERS_SET_ONLINE = 'insiders-set-online';
export const INSIDERS_LAST_NOTIFICATION = 'insiders-last-notification';
export const INSIDERS_TOGGLE_NOTIFICATION_PANEL = 'insiders-toggle-notification';
export const INSIDERS_NOTIFICATION_SUBMIT = 'insiders-notification-submit';
export const INSIDERS_NOTIFICATION_RECEIVED = 'insiders-notification-received';


export function toggleNotificationPanel(state) {
  return { type: INSIDERS_TOGGLE_NOTIFICATION_PANEL, state };
}

export function updateInsiders(insidersOnline) {
    return { type: INSIDERS_SET_ONLINE, payload: insidersOnline };
}

export function insiderFormSubmit(notification){
	return { type: INSIDERS_NOTIFICATION_SUBMIT, notification };
}

export function insiderNotificationReceived(notification){
	return dispatch => {
		dispatch( { type: INSIDERS_NOTIFICATION_RECEIVED, notification } );
		dispatch( { type: INSIDERS_TOGGLE_NOTIFICATION_PANEL, state: true } );
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/insidersAction.jsx